const { cELM } = require("../../utils");

class Question {
  constructor(params, cssname) {
    this._params = params;
    this._data = params.data;
    this.elm = this._params.style ? cELM("div", "question-block", null, this._params.style) : cELM("div", "question-block");

    if (cssname) {
      this.elm.classList.add(cssname);
    }
  }

  update(type, data, reference) {
    throw "TODO: implementation";
  }

  hideImage() {
    _imgAreaBottom.className = "image-bottom hidden";
  }

  blur() {
    let inps = elm.querySelectorAll("input");
    for (let i = 0; i < inps.length; i++) {
      inps[i].blur();
    }
  }

  getData() {
    return this._data;
  }

  getHTML() {
    // AR: case statement for different message
    let html = "";

    if (this._data.status === "typing") {
      html = `<div class="typing-notification">
<div class="dot"></div>
<div class="dot"></div>
<div class="dot"></div>
</div>`;
    } else {
      if (this._data.text) {
        html = `<div class="question-text">${this._data.text.replace("\n", "<br />")}</div>`;
      }
      if (this._data.subtext) {
        html += `<div class="subtext">${this._data.subtext.replace("\n", "<br />")}</div>`;
      }
    }

    this.elm.innerHTML = html;
    return this.elm;
  }
}

module.exports = Question;
